import Splide from '@splidejs/splide';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { EventInterface } from '@splidejs/splide';

function ImageTransition(Splide, Components) {
    const { bind } = EventInterface(Splide);
    const { Move } = Components;
    const { list } = Components.Elements;
    let endCallback;
  
    function mount() {
      const slides = Components.Slides.get();
  
      slides.forEach((Slide, i) => {
        Slide.slide.zIndex = i;
      });
  
      bind(list, "transitionend", () => {
        if (endCallback) {
          endCallback();
          endCallback = null;
        }
      });
    }
  
    function start(index, done) {
      const slides = Components.Slides.get();

      const slideOffset = index * 2;
  
      slides.forEach((Slide, i) => {
        const baseOffset = i * 2;
        const offset = slideOffset - baseOffset;
  
        if (i === index) {
            Slide.slide.style.opacity = 1;
        } else {
            Slide.slide.style.opacity = 0;
        }
        Slide.slide.style.transform = `translateX(${offset}%)`;
      });
  
      Move.jump(index);
      endCallback = done;
    }


  
    return { mount, start, cancel: () => {} };
  }

const MainHero = () => {
    const sections = document.querySelectorAll('.block-main-hero');

    for (const section of sections) {
        const splideImageElement = section.querySelector('.splide-image');
        const splideContentElement = section.querySelector('.splide-content');
        if (!splideImageElement || !splideContentElement) continue;

        const contentSlider = new Splide( splideContentElement, {
            perPage: 1,
            perMove: 1,
            mediaQuery: 'min',
            isNavigation: true,
            type: 'fade',
            drag: false,
        } );
        const imageSlider = new Splide( splideImageElement, {
            perPage: 1,
            perMove: 1,
            mediaQuery: 'min',
            arrows: false,
            pagination: false,
            drag: false,
            type: 'slide',
        } );

        lastTheme = section.dataset.theme;
        const updateTheme = (index) => {
            const slides = contentSlider.Components.Slides.get();
            if (!index) index = 0;
            const newTheme = slides[index].slide.dataset.theme;

            if (newTheme) {
                if (!lastTheme) {
                    lastTheme = section.dataset.theme;
                }
                if (lastTheme) {
                    section.classList.remove('bg-' + lastTheme);
                    section.classList.remove('fg-' + lastTheme);
                    section.classList.add('bg-' + newTheme);
                    section.classList.add('fg-' + newTheme);
                    lastTheme = newTheme;
                }
            }
        }
        
        contentSlider.on('move', (newIndex, oldIndex, destIndex) => {
            const curSlide = contentSlider.Components.Slides.getAt(newIndex).slide;
            const header = curSlide.querySelector('.header');
            const body = curSlide.querySelector('.body');
            const btn = curSlide.querySelector('.btn');

            const tl = gsap.timeline();
            tl.set([header, body, btn], { y: 20, opacity: 0 });
            tl.from(header, {
                y: 20,
                duration: 1,
                opacity: 0,
                ease: 'power4.out',
            });
            tl.from(body, {
                y: 20,
                duration: 1,
                opacity: 0,
                ease: 'power4.out',
            }, '-=0.9');
            tl.from(btn, {
                y: 20,
                duration: 1,
                opacity: 0,
                ease: 'power4.out',
            }, '-=0.9');

            updateTheme(newIndex);
        })

        contentSlider.on('mounted', updateTheme);

        contentSlider.mount();
        imageSlider.mount( {}, ImageTransition );
        contentSlider.sync( imageSlider );

        setTimeout(() => {
            const circles = section.querySelectorAll('.circle1, .circle2, .circle3');   
            circles.forEach(circle => {
               circle.classList.add('is-active');
            });
        }, 1000)
    }
}

export default MainHero;